import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useApp } from "../../contexts/AppContext";
import { useTheme } from "../../contexts/ThemeContext";
import { AppLayout } from "./AppLayout";
import { Dashboard } from "../Dashboard/Dashboard";
import { ContractRequestForm } from "../ContractRequest/ContractRequestForm";
import { ContractList } from "../Contracts/ContractList";
import { ContractRequests } from "../Contracts/ContractRequests";
import { ContractDetail } from "../Contracts/ContractDetail";
import { TemplateLibrary } from "../Templates/TemplateLibrary";
import { FileExplorer } from "../FileExplorer/FileExplorer";
import { AdminPanel } from "../Admin/AdminPanel";
import { UserManagement } from "../Admin/UserManagement";
import { AccessDenied } from "../common/AccessDenied";
import { Analytics } from "../Analytics/Analytics";
import { SupplierManagement } from "../Suppliers/SupplierManagement";
import { BulkImport } from "../Admin/BulkImport";
import { ExpiryManagement } from "../Expiry/ExpiryManagement";
import { ExpirySettings } from "../Admin/ExpirySettings";
import { ExecutionManagement } from "../Admin/ExecutionManagement";
import { AdminSignatureManager } from "../Admin/AdminSignatureManager";

export const AppRouter = () => {
  const { accessDenied, loading, isAdmin, isUser } = useApp();
  const { theme } = useTheme();

  if (loading) return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:theme.bg.primary}}>
      <div style={{textAlign:"center"}}>
        <div style={{width:48,height:48,border:"3px solid "+theme.border,borderTopColor:theme.accent,borderRadius:"50%",animation:"spin 0.8s linear infinite",margin:"0 auto 16px"}}/>
        <p style={{color:theme.text.secondary,fontFamily:"'Helvetica Neue',Helvetica,Arial,sans-serif"}}>Loading LexCore...</p>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    </div>
  );

  if (accessDenied) return <AccessDenied />;

  // Department users: only request form + their own contracts
  if (isUser) return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/request" replace />} />
        <Route path="/request" element={<ContractRequestForm />} />
        <Route path="/requests" element={<ContractRequests />} />
        <Route path="/contracts" element={<ContractList />} />
        <Route path="/contracts/:id" element={<ContractDetail />} />
        <Route path="*" element={<Navigate to="/request" replace />} />
      </Routes>
    </AppLayout>
  );

  // Admin: full access
  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/request" element={<ContractRequestForm />} />
        <Route path="/requests" element={<ContractRequests />} />
        <Route path="/contracts" element={<ContractList />} />
        <Route path="/contracts/:id" element={<ContractDetail />} />
        <Route path="/templates" element={<TemplateLibrary />} />
        <Route path="/files" element={<FileExplorer />} />
        {isAdmin && <Route path="/suppliers" element={<SupplierManagement />} />}
        {isAdmin && <Route path="/admin" element={<AdminPanel />} />}
        {isAdmin && <Route path="/admin/users" element={<UserManagement />} />}
        {isAdmin && <Route path="/admin/bulk-import" element={<BulkImport />} />}
        {isAdmin && <Route path="/admin/expiry" element={<ExpiryManagement />} />}
        {isAdmin && <Route path="/admin/expiry-settings" element={<ExpirySettings />} />}
        {isAdmin && <Route path="/admin/executions" element={<ExecutionManagement />} />}
        {isAdmin && <Route path="/admin/signatures" element={<AdminSignatureManager />} />}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AppLayout>
  );
};